<div
  *ngIf="content"
  class="eb-card"
  [attr.ghost]="ghost"
  [class.cx-card-border]="border"
  [class.cx-card-fit-to-container]="fitToContainer"
>
  <!-- Actions -->
  <div *ngIf="content.actions && !editMode" class="cx-card-actions">
    <div *ngFor="let action of content.actions">
      <div *ngIf="action.event == 'edit'">
        <button
          class="eb-card__edit-button"
          (click)="edit()"
          (keydown.enter)="edit()"
          tabindex="1"
        >
          <em class="fas fa-pen"></em>
        </button>
      </div>
    </div>
  </div>

  <!-- Card Body -->
  <div class="card-body eb-card-body" [class.cx-card-delete]="editMode">
    <!-- Edit message -->
    <div *ngIf="editMode" class="cx-card-delete-msg">
      {{ content.deleteMsg }}
    </div>
    <!-- Card title -->
    <span *ngIf="content.title" class="eb-card-title">
      {{ content.title }}
    </span>
    <!-- Card Content -->
    <div class="eb-card-container">
      <!-- Card Label -->
      <div class="cx-card-label-container">
        <div *ngIf="content.textBold" class="eb-card-label-bold">
          {{ content.textBold }}
        </div>
        <div *ngFor="let line of content.text; let i = index">
          <div *ngIf="!truncateText; else truncate" class="cx-card-label eb-card-label">
            <div *ngIf="content.loading == true && i == content.positionToShowSpinner">
              <eb-spinner class="product-detail__availability-spinner" size="2"></eb-spinner>
            </div>
            <div *ngIf="content.loading == false && i == content.positionToShowSpinner">
              {{ line }}
            </div>
            <div *ngIf="i != content.positionToShowSpinner">
              {{ line }}
            </div>
          </div>

          <ng-template #truncate>
            <cx-truncate-text-popover
              [charactersLimit]="charactersLimit"
              [content]="line"
            ></cx-truncate-text-popover>
          </ng-template>
        </div>
        <div *ngIf="content.paragraphs">
          <div  class="cx-card-paragraph" *ngFor="let item of content.paragraphs">
            <div class="cx-card-paragraph-title">{{ item.title }}</div>
            <div *ngFor="let text of item.text">
              <div class="cx-card-paragraph-text">
                {{ text }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Image -->
      <div *ngIf="content.img" class="cx-card-img-container">
        <cx-icon *ngIf="content.img === 'EXPAND'" class="new-address-image" [type]="content.img"></cx-icon>
        <cx-icon *ngIf="content.img != 'EXPAND'" [type]="content.img">
        </cx-icon>
      </div>
    </div>
  </div>
</div>
